import React, { useState } from 'react';
import '../styles/RankBadge.css';

const RankBadge = ({ rank, stats, showTooltip = true, size = 'normal' }) => {
  const [showDetails, setShowDetails] = useState(false);

  if (!rank) return null;

  const { tier, label, icon, flavor, win_rate } = rank;
  const winRatePercent = ((win_rate || 0) * 100).toFixed(1);

  return (
    <div 
      className={`rank-badge rank-${tier} rank-size-${size}`}
      onMouseEnter={() => showTooltip && setShowDetails(true)}
      onMouseLeave={() => setShowDetails(false)}
    >
      <span className="rank-icon">{icon}</span>
      <span className="rank-label">{label}</span>
      
      {showTooltip && showDetails && stats && (
        <div className="rank-tooltip">
          <div className="rank-tooltip-header">
            <span className="rank-tooltip-icon">{icon}</span>
            <span className="rank-tooltip-title">{label}</span>
          </div>
          <div className="rank-tooltip-stats">
            <div className="rank-stat-row">
              <span className="stat-label">Win Rate:</span>
              <span className="stat-value">{winRatePercent}%</span>
            </div>
            <div className="rank-stat-row">
              <span className="stat-label">🏆 Wins:</span>
              <span className="stat-value">{stats.wins || 0}</span>
            </div>
            <div className="rank-stat-row">
              <span className="stat-label">💔 Losses:</span>
              <span className="stat-value">{stats.losses || 0}</span>
            </div>
            <div className="rank-stat-row">
              <span className="stat-label">🏳️ Resigns:</span>
              <span className="stat-value">{stats.resignations || 0}</span>
            </div>
          </div>
          <div className="rank-tooltip-flavor">
            {flavor}
          </div>
        </div>
      )}
    </div>
  );
};

export default RankBadge;
